'use strict';
module.exports = function(app) {
    app.filter('addSpaceToNumber', function () {
        return function (input) {
            var input = input.toString();
            var x = input.split('.');
            var x1 = x[0];
            var x2 = x.length > 1 ? '.' + x[1] : '';
            var rgx = /(\d+)(\d{3})/;
            while (rgx.test(x1)) {
                x1 = x1.replace(rgx, '$1' + ' ' + '$2');
            }
            return x1 + x2;
        };
    });
};



/*****************
 ** WEBPACK FOOTER
 ** ./dash_board/js/add_space_to_number.filter.js
 ** module id = 45
 ** module chunks = 0
 **/